const ADD_REQUESTS = 'ADD_REQUESTS';
const REMOVE_REQUESTS = 'REMOVE_REQUESTS';
const SET_LOADING = 'SET_LOADING';

const state = {
  flag: false,
  requests: []
};

const getters = {
  isLoading: state => {
    return state.flag || state.requests.length > 0;
  }
};

const mutations = {
  [ADD_REQUESTS] (state, mark) {
    state.requests.push(mark);
  },
  [REMOVE_REQUESTS] (state, mark) {
    const index = state.requests.indexOf(mark);
    if (index > -1) {
      state.requests.splice(index, 1);
    }
  },
  [SET_LOADING] (state, loading) {
    state.flag = loading;
  }
};

const actions = {
  addRequest ({commit, mark}) {
    commit(ADD_REQUESTS, mark);
  },
  removeRequest ({commit, mark}) {
    commit(REMOVE_REQUESTS, mark);
  },
  setLoading ({commit}) {
    commit(SET_LOADING, true);
  },
  clearLoading ({commit}) {
    commit(SET_LOADING, false);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/core/index.js